import { action } from 'easy-peasy';
import AnalyticsModel from './types/AnalyticsModel';
import { mapElevarCustomerData } from './types/mappers';

const analyticsModel: AnalyticsModel = {
  // state
  elevarCustomerData: null,
  arrivedFromPage: undefined,
  isElevarInitializationFinished: false,

  // actions
  setElevarCustomerData: action((state, data) => {
    state.elevarCustomerData = mapElevarCustomerData(data);
  }),
  setArrivedFromPage: action((state, payload) => {
    state.arrivedFromPage = payload;
  }),
  setIsElevarInitializationFinished: action((state, payload) => {
    state.isElevarInitializationFinished = payload;
  }),
  unsetElevarCustomerData: action(state => {
    state.elevarCustomerData = null;
  }),
};

export default analyticsModel;
